import Http from '../http';

export default {
  index(filter) {
    return Http.get(`/enrolleds`, {params: {...filter}})
  },

  resendConfirmEmail(enrolledId) {
    return Http.post(`/enrolleds/${enrolledId}/resend_confirm_email`)
  },
  
  update(enrolled){
    return Http.put(`/enrolleds/${enrolled.id}`, {
      enrolled: {
        ...enrolled,
      },
    });
  },
}